import { Component, Input } from '@angular/core';

@Component({
  selector: 'kt-dashboard-button',
  templateUrl: './dashboard-button.component.html',
  styleUrls: ['./dashboard-button.component.scss'],
})
export class DashboardButtonComponent {
  @Input() color:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'danger'
    | 'warning'
    | 'success'
    | 'neutral' = 'neutral';
  @Input() title: string;
  @Input() iconPath: string;
  @Input() bodyContent: any;
  @Input() footerContent: any;
  @Input() activated: boolean;
}
